<div class="container-fluid bg-{{ backgroundColor }} py-2">
  <div class="row" style="align-items: center">
    <div class="col-2 col-md-3">
      <a routerLink="/">
        <img alt="enin-logo" style="height: 20px; width: auto" src="app/assets/img/logo_white_symbol.svg" height="25" />
      </a>
    </div>
    <div class="col-md-9 col-10 ms-auto text-right">
      <nk-top-search style="display: inline-block" class="me-2 text-left"></nk-top-search>

      <button
        type="button"
        class="btn btn-secondary"
        (click)="collapsedMainNav = !collapsedMainNav; collapedUserNav = true"
        [attr.aria-expanded]="!collapsedMainNav"
        aria-controls="collapseBasic">
        <i class="fa fa-bars"></i>
      </button>
    </div>
  </div>
</div>
<nav class="navbar navbar-dark bg-primary p-0">
  <div class="container-fluid">
    <div id="collapseBasic" [collapse]="collapsedMainNav" [isAnimated]="true" class="navbar-collapse">
      <ul class="navbar-nav mr-auto mt-2 mb-2 mb-lg-0 mt-lg-0 mx-2">
        <li class="nav-item">
          <a
            class="nav-link"
            [class.active]="item.active"
            *ngFor="let item of navigationPaths$ | async"
            [routerLink]="item.url">
            <i class="fa fa-{{ item.icon }} me-2"></i> {{ item.name }}
          </a>
        </li>
        <hr class="my-1" />
        <nk-user-menu-mobile
          [hideNavItems]="{ logoutMicrosoft: true }"
          [dropdownId]="'collapseUserMenu'"
          [collapsedNav]="collapedUserNav"></nk-user-menu-mobile>
        <hr class="my-1" />
        <li class="nav-item my-1">
          <nk-feedback-button
            andClass="nav-link btn btn-link normal-case"
            [label]="'feedback_button.label_short_text' | translate"></nk-feedback-button>
        </li>
      </ul>
    </div>
  </div>
</nav>
